import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user) navigate("/");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const res = await login(username.trim(), password);
    setBusy(false);
    if (res.ok) {
      toast.success("Welcome back!");
      navigate("/");
    } else {
      toast.error(res.error || "Login failed");
    }
  };

  const quickFill = (u, p) => {
    setUsername(u);
    setPassword(p);
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Left visual */}
      <div
        className="hidden lg:block relative"
        style={{
          backgroundImage:
            "linear-gradient(rgba(15,23,42,.55),rgba(30,58,138,.75)), url('https://images.pexels.com/photos/16176576/pexels-photo-16176576.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 flex flex-col justify-end p-12 text-white">
          <img src="/logo.png" alt="A1" className="w-20 h-20 rounded-full mb-6 border-2 border-white/30" />
          <h1 className="font-head font-black text-5xl tracking-tight leading-none">A1 CARS AGENCY</h1>
          <p className="text-lg font-semibold text-white/80 mt-3 max-w-md">
            Simple counter software for stock, sales &amp; daily cash — since 1981.
          </p>
        </div>
      </div>

      {/* Right form */}
      <div className="flex items-center justify-center p-6 bg-white">
        <form onSubmit={submit} className="w-full max-w-sm a1-fade" data-testid="login-form">
          <div className="lg:hidden flex items-center gap-3 mb-8">
            <img src="/logo.png" alt="A1" className="w-14 h-14 rounded-full border border-slate-200" />
            <div>
              <div className="font-head font-black text-2xl tracking-tight">A1 CARS</div>
              <div className="text-xs font-bold text-slate-400 tracking-widest">SINCE 1981</div>
            </div>
          </div>

          <h2 className="font-head font-black text-3xl tracking-tight mb-1">Sign In</h2>
          <p className="text-slate-500 font-medium mb-8">Enter your staff login to continue.</p>

          <label className="a1-label">Username</label>
          <input
            data-testid="login-username"
            className="a1-input mb-5"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="admin"
            autoComplete="username"
          />
          <label className="a1-label">Password</label>
          <input
            data-testid="login-password"
            type="password"
            className="a1-input mb-6"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            autoComplete="current-password"
          />

          <button data-testid="login-submit" disabled={busy} className="a1-btn a1-btn-action w-full">
            {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : "Sign In"}
          </button>

          <div className="mt-6 grid grid-cols-2 gap-3">
            <button type="button" onClick={() => quickFill("admin", "admin123")} className="a1-btn a1-btn-ghost !h-11 !text-sm">
              Use Owner
            </button>
            <button type="button" onClick={() => quickFill("manager", "manager123")} className="a1-btn a1-btn-ghost !h-11 !text-sm">
              Use Manager
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
